module.exports = __webpack_public_path__ + "static/media/paypak-logo.e686e963.png";